<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <div class="attainmentCO" v-else>
      <b-row>
        <b-col md="12">
          <div class="viewOrConfig mb-3">
            <b-button size="sm" :variant="config ? 'success' : 'outline-primary'" class="font-weight-bolder"
              disabled>Configured</b-button>
            <b-button size="sm" disabled :variant="!config ? 'success' : 'outline-primary'"
              class="ml-4 font-weight-bolder">View Data</b-button>
          </div>

          <div class=" " v-if="config">
            <table class="table table-bordered table-striped">
              <thead class="thead-dark text-left">
                <tr>
                  <th>
                    Si. No.
                  </th>
                  <th>Method</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(method, assignmentIndex) in methods" :key="assignmentIndex">
                  <td class="align-middle">
                    <b-form-checkbox size="sm" v-model="selectedmethods" :value="method.id">
                    </b-form-checkbox>
                  </td>
                  <td class="align-middle">
                    {{ method.name }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div v-else>
            <h4>methods</h4>
            <div class="mt-5">
              <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th>Method</th>
                    <th>Parameter</th>
                    <th>COs</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(method, mIndex) in methods">
                    <tr v-for="(p_id, pIndex) in method.parameters" :key="`${method.id}-${p_id}`">
                      <td v-if="pIndex === 0" :rowspan="method.parameters.length">{{ mIndex + 1 }}) {{ method.name }}
                      </td>
                      <td>
                        {{ parameters[p_id] ? parameters[p_id].name : '' }}
                      </td>
                      <td>
                        {{parameters[p_id] && parameters[p_id].course_outcomes.length
                          ? parameters[p_id].course_outcomes.map(co => co.code).join(', ')
                          : ''}}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
            <br>

            <h4>Evaluation Scores</h4>
            <div class=" ">
              <div class="table-responsive rounded">
              <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th rowspan="3">Sl. No.</th>
                    <th rowspan="3">Student</th>
                    <th v-for="(method, mIndex) in methods" :key="'method-' + mIndex"
                      :colspan="method.parameters.length">
                      {{ method.name }}
                    </th>
                  </tr>
                  <tr>
                    <template v-for="method in methods">
                      <th v-for="paramId in method.parameters" :key="'param-' + paramId" class="align-middle">
                        {{ parameters[paramId].name }}<br>
                        Max Score: {{ parameters[paramId].maximum_score }}
                        <br>
                        <template
                          v-if="parameters[paramId].course_outcomes && parameters[paramId].course_outcomes.length">
                          <span v-for="(co, coIndex) in parameters[paramId].course_outcomes" :key="coIndex">
                            {{ co.code }}<span v-if="coIndex !== parameters[paramId].course_outcomes.length - 1">,
                            </span>
                          </span>
                        </template>
                      </th>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(student,
                    sIndex) in course_students" :key="sIndex">
                    <td>{{ (sIndex + 1) }}</td>
                    <td class="align-middle">
                      {{ student.first_name }}{{ student.last_name }}
                    </td>
                    <template v-for="method in methods">
                      <td class="align-middle" v-for="paramId in method.parameters" :key="'param-' + paramId">
                        {{ evaluation_scores[student.id][paramId]['score'] }}
                      </td>
                    </template>

                  </tr>
                </tbody>
              </table>
              </div>
            </div>
            <br>

            <h4>Evaluation CO Scores </h4>
            <div class=" ">
              <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th class="align-middle">Sl. No.</th>
                    <th class="align-middle">Student</th>
                    <th class="align-middle" v-for="(co, coIndex) in course_outcomes" :key="coIndex">
                      {{ co.code }}<br> Score(%) <br>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(student,
                    sIndex) in course_students" :key="sIndex">
                    <td>{{ (sIndex + 1) }}</td>
                    <td class="align-middle">
                      {{ student.first_name }}{{ student.last_name }}
                    </td>
                    <td class="align-middle" v-for="(co, cosIndex) in course_outcomes" :key="cosIndex">
                      <span v-if="evaluation_co_scores[student.id] && evaluation_co_scores[student.id][co.id]">
                        {{ evaluation_co_scores[student.id][co.id]['score'] }}/
                        {{ evaluation_co_scores[student.id][co.id]['max'] }}
                        ({{ handleValue(evaluation_co_scores[student.id][co.id]['percentage']) }})
                      </span>
                      <span v-else>-</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br>

            <h4>project Evaluation Attainment</h4>
            <div class=" ">
              <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th>CO</th>
                    <th>Total Students</th>
                    <th>Target %</th>
                    <th>Students achieved target</th>
                    <th>% of students achieved target</th>
                    <th>Attainment level</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(co,
                    coIndex) in course_outcomes" :key="coIndex">
                    <td class="align-middle">
                      {{ co.code }}
                    </td>
                    <td>{{ project_computed_co_data[co.id] ? project_computed_co_data[co.id]['max_student_count'] : '-'
                    }}</td>
                    <td>{{ co_target_percentages[co.id] ? co_target_percentages[co.id] : '-' }}</td>
                    <td>{{ project_computed_co_data[co.id] ? project_computed_co_data[co.id]['target_achived_students']
                      : '-' }}
                    </td>
                    <td>
                      {{
                        project_computed_co_data[co.id] ?
                          project_computed_co_data[co.id]['target_achived_percentage']
                          : '-'
                      }}
                    </td>
                    <td>
                     <span v-if="project_computed_co_data[co.id]['attainment_level'] === null">
                        -
                     </span>
                     <span v-else>
                        <span v-if="project_computed_co_data[co.id]['attainment_level'] > 0">
                          {{ project_computed_co_data[co.id]['attainment_level'] }}
                        </span>
                     </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <br>

            <h4>project Attainment</h4>
            <div class=" ">
              <table class="table table-bordered table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th v-for="(co,
                      coIndex) in course_outcomes" :key="coIndex">{{ co.code }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td v-for="(co,
                      coIndex) in course_outcomes" :key="coIndex">
                      <span v-if="project_computed_co_data[co.id]['attainment_level'] === null">
                          -
                      </span>
                      <span v-else>
                          <span v-if="project_computed_co_data[co.id]['attainment_level'] > 0">
                            {{ project_computed_co_data[co.id]['attainment_level'] }}
                          </span>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  props: ["courseReport"],
  async created() {
    this.fetchData = true;
    await this.getAttainmentConfigration();
    this.fetchData = false;
  },

  data() {
    return {
      fetchData: false,
      config: true,
      methods: [],
      parameters: [],
      selectedmethods: [],
      co_target_percentages: {},
      evaluation_scores: {},
      course_outcomes: {},
      course_students: [],
      evaluation_co_scores: {},
      project_computed_co_data: {},
      avg_attainment_level: {},
    };
  },
  methods: {
    handleValue(num) {
      if (isNaN(num)) {
        return "";
      } else {
        return num % 1 == 0 ? Math.floor(num) : parseFloat(num).toFixed(2);
      }
    },
    async getAttainmentConfigration() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/coattainment/getconfig`;
      await this.$axios
        .post(url, {
          course: this.courseReport.course_id,
          step: "project",
        })
        .then((response) => {
          let selected_methods = response.data.selected_methods;
          this.methods = response.data.methods;
          this.methods.forEach((method) => {
            if (selected_methods.includes(method.id)) this.selectedmethods.push(method.id);
          });
        });
    },
    async setAttainmentConfigration() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/coattainment/setconfig`;
      await this.$axios
        .post(url, {
          course: this.courseReport.course_id,
          step: "project",
          methods: this.selectedmethods,
        })
        .then(() => { });
    },
    async getAttainmentData() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/coattainment/getdata`;
      await this.$axios
        .post(url, {
          course: this.courseReport.course_id,
          step: "project",
        })
        .then((response) => {
          this.evaluation_scores = response.data.evaluation_scores;
          this.methods = response.data.methods;
          this.parameters = response.data.parameters;
          this.course_outcomes = response.data.course_outcomes;
          this.course_students = response.data.course_students;
        });
    },
    async getAttainmentReport() {
      const url =
        this.$store.getters.getAPIKey.mainAPI + `/coattainment/report`;
      await this.$axios
        .post(url, {
          course: this.courseReport.course_id,
          step: "project",
        })
        .then((response) => {
          this.evaluation_co_scores = response.data.evaluation_co_scores;
          this.project_computed_co_data = response.data.project_computed_co_data;
          this.avg_attainment_level = response.data.avg_attainment_level;
          this.co_target_percentages = response.data.co_target_percentages;
        });
    },
  },
};
</script>
